import styles from "./RemoveAdminModal.module.css";
import PropTypes from "prop-types";
import classNames from "classnames";
import { Modal } from "shared/Modal";

/**
 *
 * Modal used for confirmation of removing an admin on the admins tab of the groups page.
 *
 */

export function RemoveAdminModal({ isOpen, onClose, onClick, adminInfo }) {
  if (!isOpen) {
    return "";
  }
  return (
    <div className={styles.container}>
      <Modal
        isOpen={isOpen}
        title="REMOVE ADMIN"
        closeBtn="none"
        className={styles.modal}
        onClose={onClose}
        children={
          <>
            <div className={styles.description}>
              Confirm that you would like to remove the user's admin
              permissions.
            </div>

            <div className={styles.grid}>
              <div className={styles.bold}>Name</div>
              <div className={styles.item}>{adminInfo.adminName}</div>
              <div className={styles.bold}>IBO #</div>
              <div>{adminInfo.iboNum}</div>
            </div>

            <div className={styles.buttonContainer}>
              <button
                className={classNames(styles.button, styles.cancelBtn)}
                onClick={onClose}
              >
                CANCEL
              </button>
              <button className={styles.button} onClick={onClick}>
                REMOVE
              </button>
            </div>
          </>
        }
      />
    </div>
  );
}

RemoveAdminModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  onClick: PropTypes.func,
  adminInfo: PropTypes.object,
};
